import React, { Component } from 'react'
import './App.css'
import Layers from '../Layers/Layers'
import MenuItems from '../../data/menu.js'
import Contribute from '../Contribute/Contribute'
import About from '../About/About'
import VisibleLayersMap from '../../containers/VisibleLayersMap'
import SetSkinMenu from '../../containers/SetSkinMenu'
import $ from "jquery"


class App extends Component {

  toggleContribute(e) {
    e.preventDefault()
    $('#contribute').toggle()
  }

  toggleAbout(e) {
    e.preventDefault()
    $('#about').fadeIn()
  }

  render() {
    return (
      <div id="map" className="App">
        <a id="logo" href="/">CAST</a>
        <div className="map--gradient"></div>
        <div className="layer-info"></div>
        <VisibleLayersMap />
        <Layers />
        <SetSkinMenu menuItems={ MenuItems } />
        <Contribute />
        <About />
        <a className="about-btn" href="#about" onClick={ (e) => this.toggleAbout(e) }>i</a>
        <a className="submit-organization" href="#submit" onClick={ (e) => this.toggleContribute(e) }>Contribute to this map</a>
        <div className="mobile"><span>Please explore this map on a larger device.</span></div>
        <a className="attribution-stamen" href="http://stamen.com">Designed and built by Stamen</a>
        <div className="loader">
        <svg width="44" height="44" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg" stroke="#44AFC5">
            <g fill="none" fill-rule="evenodd" stroke-width="2">
                <circle cx="22" cy="22" r="1">
                    <animate attributeName="r"
                        begin="0s" dur="1.8s"
                        values="1; 20"
                        calcMode="spline"
                        keyTimes="0; 1"
                        keySplines="0.165, 0.84, 0.44, 1"
                        repeatCount="indefinite" />
                    <animate attributeName="stroke-opacity"
                        begin="0s" dur="1.8s"
                        values="1; 0"
                        calcMode="spline"
                        keyTimes="0; 1"
                        keySplines="0.3, 0.61, 0.355, 1"
                        repeatCount="indefinite" />
                </circle>
                <circle cx="22" cy="22" r="1">
                    <animate attributeName="r"
                        begin="-0.9s" dur="1.8s"
                        values="1; 20"
                        calcMode="spline"
                        keyTimes="0; 1"
                        keySplines="0.165, 0.84, 0.44, 1"
                        repeatCount="indefinite" />
                    <animate attributeName="stroke-opacity"
                        begin="-0.9s" dur="1.8s"
                        values="1; 0"
                        calcMode="spline"
                        keyTimes="0; 1"
                        keySplines="0.3, 0.61, 0.355, 1"
                        repeatCount="indefinite" />
                </circle>
            </g>
        </svg>
        </div>
      </div>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js